/* RESPONSIBLE TEAM: team-reporting */

import type { ChartType } from '@/features/report-snapshots/types';

export const VISUALIZATION_TYPE_GRID_SIZES = {
  column: {
    minWidth: 3,
    minHeight: 4,
    defaultWidth: 6,
    defaultHeight: 5,
  },
  counter: {
    minWidth: 2,
    minHeight: 2,
    defaultWidth: 3,
    defaultHeight: 3,
  },
  heatmap: {
    minWidth: 4,
    minHeight: 4,
    defaultWidth: 12,
    defaultHeight: 8,
  },
  tabular: {
    minWidth: 3,
    minHeight: 4,
    defaultWidth: 12,
    defaultHeight: 8,
  },
  line: {
    minWidth: 3,
    minHeight: 4,
    defaultWidth: 6,
    defaultHeight: 5,
  },
  bar: {
    minWidth: 3,
    minHeight: 2,
    defaultWidth: 6,
    defaultHeight: 3,
  },
  area: {
    minWidth: 3,
    minHeight: 4,
    defaultWidth: 6,
    defaultHeight: 5,
  },
  donut: {
    minWidth: 2,
    minHeight: 5,
    defaultWidth: 3,
    defaultHeight: 6,
  },
  pie: {
    minWidth: 2,
    minHeight: 5,
    defaultWidth: 3,
    defaultHeight: 6,
  },
  combo: {
    minWidth: 3,
    minHeight: 4,
    defaultWidth: 6,
    defaultHeight: 5,
  },
  banner: {
    minWidth: 3,
    minHeight: 1,
    defaultWidth: 12,
    defaultHeight: 1,
  },
  'data-table': {
    minWidth: 12,
    minHeight: 6,
    defaultWidth: 12,
    defaultHeight: 6,
  },
} as const;

export function getMinimumSizeConstraints(visualizationType: ChartType) {
  const constraints =
    VISUALIZATION_TYPE_GRID_SIZES[visualizationType as keyof typeof VISUALIZATION_TYPE_GRID_SIZES];

  return {
    minWidth: constraints.minWidth,
    minHeight: constraints.minHeight,
  };
}

export function getDefaultSizeConstraints(visualizationType: ChartType) {
  const constraints =
    VISUALIZATION_TYPE_GRID_SIZES[visualizationType as keyof typeof VISUALIZATION_TYPE_GRID_SIZES];

  return {
    defaultWidth: constraints.defaultWidth,
    defaultHeight: constraints.defaultHeight,
  };
}
